var exports = {
  "k": "xdbfd91f1--7e961a--container",
};

module.exports = exports;
